import { render, staticRenderFns } from "./BlogArticles.vue?vue&type=template&id=153ed838"
import script from "./BlogArticles.vue?vue&type=script&lang=ts"
export * from "./BlogArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports